import {
    FETCH_TAXDETAILS_BEGIN,
    FETCH_TAXDETAILS_SUCCESS,
    FETCH_TAXDETAILS_FAILURE,
    FETCH_TAXENTITYCONTACTS_BEGIN,
    FETCH_TAXENTITYCONTACTS_SUCCESS,
    FETCH_TAXENTITYCONTACTS_FAILURE,

    FETCH_TAXENTITYCONTACTACCESS_BEGIN,
    FETCH_TAXENTITYCONTACTACCESS_SUCCESS,
    FETCH_TAXENTITYCONTACTACCESS_FAILURE,

    FETCH_GETCONTACTROLEACCESS_BEGIN,
    FETCH_GETCONTACTROLEACCESS_SUCCESS,
    FETCH_GETCONTACTROLEACCESS_FAILURE,

    FETCH_GETCONTACTROLE_BEGIN,
    FETCH_GETCONTACTROLE_SUCCESS,
    FETCH_GETCONTACTROLE_FAILURE,
} from '../constants/taxdetails';

const initialState={
    taxDetails:[],
    taxSummary: {},
    TaxEntityContactAccess: [],
    TaxEntityContacts: [],
    ContactRole: [],
    ContactRoleDefaccess:[],
    isLoading:false,
    error:""
}

export const getTaxDetailsReducer = (state = initialState, action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_TAXDETAILS_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_TAXDETAILS_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            taxSummary:payload.taxDetails,
            taxDetails:payload.taxDetails
        };
    case FETCH_TAXDETAILS_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}


export const TaxEntityContactsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_TAXENTITYCONTACTS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_TAXENTITYCONTACTS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,             
                TaxEntityContacts: payload.TaxEntityContacts
            };
        case FETCH_TAXENTITYCONTACTS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


export const TaxEntityContactAccessReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_TAXENTITYCONTACTACCESS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_TAXENTITYCONTACTACCESS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,               
                TaxEntityContactAccess: payload.TaxEntityContactAccess
            };
        case FETCH_TAXENTITYCONTACTACCESS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


export const GetContactRoleReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_GETCONTACTROLE_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_GETCONTACTROLE_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                ContactRole: payload.ContactRole
            };
        case FETCH_GETCONTACTROLE_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


export const GetContactRoleAccessReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_GETCONTACTROLEACCESS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_GETCONTACTROLEACCESS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                ContactRoleDefaccess: payload.ContactRoleDefaccess
            };
        case FETCH_GETCONTACTROLEACCESS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}







